module.exports = __webpack_public_path__ + "san-francisco-text-regular.b6ea4ad92b29f79c61cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/san-francisco-text-regular.svg
// module id = 952
// module chunks = 32